import { LIKE_TWEET } from "./constants";

const initialState = {
  tweets: [
    {
      id: 1,
      message:
        "نتيجةً لتطبيق بعض مبادرات تحسين الخدمات تم رفع سعادة المتعاملين من 80% إلى 92% ",
      entityName: "جهة حكومية",
      date: "13.12.2018",
      isLiked: false,
      comment: "ثابر على العمل الجيد"
    },
    {
      id: 2,
      message: "رفع رضا المتعاملين عن الخدمة من 86% إلى 92% ",
      isLiked: false,
      entityName: "جهة حكومية",
      date: "13.12.2018",
      comment: null
    },
    {
      id: 3,
      message: "نسبة 81% في مؤشر رضا المتعاملين، مقارنة بـ 43% قبل التحسين ",
      entityName: "النيابة العامة ",
      date: "13.12.2018",
      isLiked: true,
      comment: null
    },
    {
      id: 4,
      message: "نسبة 81% في مؤشر رضا المتعاملين، مقارنة بـ 43% قبل التحسين ",
      entityName: "النيابة العامة ",
      date: "13.12.2018",
      isLiked: true,
      comment: null
    }
  ]
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LIKE_TWEET:
      const index = state.tweets.findIndex(tweet => tweet.id === payload.id);
      return {
        ...state,
        tweets: [
          ...state.tweets.slice(0, index),
          {
            ...state.tweets[index],
            isLiked: !state.tweets[index].isLiked
          },
          ...state.tweets.slice(index + 1)
        ]
      };

    default:
      return state;
  }
};
